import { createAction } from 'redux-actions';
import * as types from './actionTypes';
import {
  updateConsultationAppointor,
  updateConsultationCompany
} from '../../utils/api';

// common
export const putRequest = createAction(types.PUT_REQUEST)
export const putSuccess = createAction(types.PUT_SUCCESS)
export const putFailure = createAction(types.PUT_FAILURE)

export function doUpdateAppointor(consultationId, appointDate, name, address, phone, email, relationship, ssid, birthday) {
  return dispatch => {
    dispatch(putRequest());
    updateConsultationAppointor(consultationId, appointDate, name, address, phone, email, relationship, ssid, birthday).then(data => {
      dispatch(putSuccess());
    }).catch((errMsg) => {
      dispatch(putFailure({ errMsg }));
    })
  }
}

export function doUpdateCompany(consultationId, appointDate, name, address, phone, email, ban, representative, contactPerson) {
  return dispatch => {
    dispatch(putRequest());
    updateConsultationCompany(consultationId, appointDate, name, address, phone, email, ban, representative, contactPerson).then(data => {
      dispatch(putSuccess());
    }).catch((errMsg) => {
      dispatch(putFailure({ errMsg }));
    })
  }
}

